module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2MDIuNzI0IiBoZWlnaHQ9IjU5OS4wOTgiIHZpZXdCb3g9IjAgMCA2MDIuNzI0IDU5OS4wOTgiPgogIDxwYXRoIGlkPSJQYXRoXzc2IiBkYXRhLW5hbWU9IlBhdGggNzYiIGQ9Ik01OTkuMSwwVjYwMi43MjRIMFoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAgNTk5LjA5OCkgcm90YXRlKC05MCkiIGZpbGw9InJnYmEoMCwxMTYsMTY5LDAuNDIpIi8+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./assets/img/blue-corner.svg
// module id = 11
// module chunks = 0